import React, {Component} from 'react';
import css from './login.scss';
import gql from 'graphql-tag';
import {Mutation} from 'react-apollo';

const LOGIN = gql`
	mutation($email: String!, $password: String!) {
		login(email: $email, password: $password, asAdmin: true) {
			token
		}
	}
`;

class Login extends Component {
	state = {
		email: '',
		password: '',
	};
	updateState = e => {
		let state = {};
		state[e.target.name] = e.target.value;
		this.setState(_ => state);
	};
	onceLoggedIn = ({login: {token}}) => {
		localStorage.setItem('token', token);
		this.props.history.push('utilisateurs');
	};
	render() {
		return (
			<Mutation
				mutation={LOGIN}
				variables={this.state}
				update={this.updateCache}
				onCompleted={this.onceLoggedIn}
			>
				{(login, {data, loading, error}) => {
					return (
						<form
							className={css.form}
							onSubmit={e => {
								e.preventDefault();
								login();
							}}
						>
							<h1 className={css.h1}>Connexion</h1>
							<input
								type="email"
								placeholder="Email"
								className={css.input}
								name="email"
								onChange={this.updateState}
								value={this.state.email}
								required
								disabled={loading}
							/>
							<input
								type="password"
								placeholder="Mot de passe"
								className={css.input}
								name="password"
								onChange={this.updateState}
								value={this.state.password}
								required
								disabled={loading}
							/>
							{error && (
								<div className={css.error}>
									{error.graphQLErrors[0]}
								</div>
							)}
							<button
								type="submit"
								className={css.button}
								disabled={loading}
							>
								Entrer
							</button>
						</form>
					);
				}}
			</Mutation>
		);
	}
}

export default Login;



// WEBPACK FOOTER //
// ./src/login/login.js